import { getSizeDimensionsLabel, type SavedSize } from '@air/feature-saved-sizes/utils';

export const getSavedSizeOptionLabel = (savedSize: SavedSize): string =>
  `${savedSize.name} (${getSizeDimensionsLabel(savedSize)})`;
